import { Injectable } from '@angular/core';

@Injectable()
export class ChoiceService {

    public product: any[] = [];

}